/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="../isimpleattributes.d.ts" />

module App.Common.Services {
	'use strict';

	export class EnumHelperService {

		public getNames(e: any) {
			return Object.keys(e).filter(x => isNaN(parseInt(x, 10)));
		}

		public getValues(e: any) {
			return Object.keys(e).map(x => parseInt(x, 10)).filter(x => !isNaN(x));
		}

		public getNamesAndValues(e: any) {
			return this.getValues(e).map(x => {return {name: e[x] as string, value: x};});
		}

		public hasName(e: any, name: string) {
			return !!this.getNames(e).indexOf(name);
		}

		public hasValue(e: any, value: number) {
			return !!this.getValues(e).indexOf(value);
		}

		public getValue(e: any, name: string) {
			return e[name];
		}

		public getName(e: any, value: number) {
			return e[value];
		}

	}

	angular
		.module('app.common.services')
		.service('app.common.services.enumHelperService', EnumHelperService);
}